import React from "react";
import { CheckCircle2, AlertCircle, HelpCircle } from "lucide-react";

// Sprint 11 Light — Confidence-Badge mit Quellen-Anzeige.
//   keyword         → 🟢 hohe Confidence (klarer Keyword-Match)
//   llm_validierung → 🟡 mittlere Confidence (LLM-Backup hat geholfen)
//   keine_klaren_signale → 🔴 niedrig (nicht eindeutig)

const VARIANTS = {
  keyword: {
    icon: CheckCircle2,
    bg: "bg-emerald-50 dark:bg-emerald-950/40",
    border: "border-emerald-200 dark:border-emerald-800/60",
    text: "text-emerald-900 dark:text-emerald-100",
    iconColor: "text-emerald-700 dark:text-emerald-300",
    label: "Klares Signal",
    emoji: "🟢",
  },
  llm_validierung: {
    icon: AlertCircle,
    bg: "bg-amber-50 dark:bg-amber-950/40",
    border: "border-amber-200 dark:border-amber-800/60",
    text: "text-amber-900 dark:text-amber-100",
    iconColor: "text-amber-700 dark:text-amber-300",
    label: "Wahrscheinliches Muster",
    emoji: "🟡",
  },
  keine_klaren_signale: {
    icon: HelpCircle,
    bg: "bg-rose-50 dark:bg-rose-950/40",
    border: "border-rose-200 dark:border-rose-800/60",
    text: "text-rose-900 dark:text-rose-100",
    iconColor: "text-rose-700 dark:text-rose-300",
    label: "Nicht eindeutig",
    emoji: "🔴",
  },
};

export default function ConfidenceBadge({ quelle, confidence, hinweis }) {
  const variant = VARIANTS[quelle] || VARIANTS.keyword;
  const Icon = variant.icon;
  const pct = Math.round(Number(confidence || 0) * 100);
  return (
    <div
      data-testid="confidence-badge"
      data-confidence-quelle={quelle}
      className={`flex items-start gap-2.5 rounded-lg border ${variant.bg} ${variant.border} px-3 py-2`}
    >
      <Icon className={`w-4 h-4 ${variant.iconColor} flex-shrink-0 mt-0.5`} />
      <div className="flex-1 min-w-0">
        <p className={`text-xs font-bold uppercase tracking-wider ${variant.text}`}>
          <span aria-hidden="true">{variant.emoji}</span> {variant.label} · {pct}%
        </p>
        {hinweis && (
          <p
            data-testid="confidence-hinweis"
            className={`mt-0.5 text-xs ${variant.text} opacity-80 leading-relaxed`}
          >
            {hinweis}
          </p>
        )}
      </div>
    </div>
  );
}
